export default "__VITE_ASSET__DZ6GMySI__"